import React from 'react';
import { Box, Text, HStack, Switch } from '@chakra-ui/react';

interface SettingSwitchRowProps {
    label: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
}

const SettingSwitchRow: React.FC<SettingSwitchRowProps> = ({
    label,
    checked,
    onCheckedChange,
    disabled = false,
}) => {
    return (
        <HStack w="full" justify="space-between" align="center" py={3} gap={4}>
            <Box flex={1} minW={0} maxW="90%">
                <Text
                    fontSize="md"
                    color={disabled ? 'gray.400' : 'black'}
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                >
                    {label}
                </Text>
            </Box>
            <Box flexShrink={0}>
                <Switch.Root
                    checked={checked}
                    onCheckedChange={(details) => onCheckedChange(details.checked)}
                    colorPalette="black"
                    size="lg"
                    disabled={disabled}
                >
                    <Switch.HiddenInput />
                    <Switch.Control bg={checked ? 'yellow.600' : 'gray.300'}>
                        <Switch.Thumb />
                    </Switch.Control>
                </Switch.Root>
            </Box>
        </HStack>
    );
};

export default SettingSwitchRow;
